import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const RadioLabel = styled.label`
  display: block;
  width: 130px;
  //margin-top: -25px;
  text-align: end;
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.45;
  color: var(--title-text-color);
  cursor: pointer;

  @media ${device.desktop} {
    width: 160px;
    font-size: 13px; //10
    line-height: 1.4; //1.4
  }
`;

export const RadioInput = styled.input`
  //position: relative;
  position: absolute;
  display: inline-block;
  width: 15px;
  height: 15px;
  //margin-right: 10px;
  //margin-bottom: 15px;
  bottom: 10px;
  right: 10px;

  cursor: pointer;
  pointer-events: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transform-origin: center;
  border: 1px solid var(--bg-button);
  border-radius: 50% 50%;
  background-color: transparent;
  transition: 120ms all ease-in-out;

  &::before {
    position: absolute;
    content: "";
    border-radius: 50%;
  }

  &::before {
    top: 3px;
    left: 3px;
    width: 7px;
    height: 7px;
    pointer-events: all;
    transition: 120ms all ease-in-out;
  }

  &:checked {
    transform: scale(1.2);
    transition: background-color 120ms ease-in-out;

    &::before {
      width: 7px;
      height: 7px;
      background: var(--bg-button);
    }
  }
`;

export const RadioText = styled.span`
  display: block;
  width: 100%;
  text-align: start;
`;

export const ThumbaImage = styled.div`
  position: relative;
  width: 130px;
  height: 130px;
  border-radius: 5px;
  overflow: hidden;

  @media ${device.desktop} {
    width: 160px;
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;
